<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "DetailBanner",
    props: [ "data" ],
    data() {
        return {
            options: {
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                loop: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="banner">
        <swiper ref="swiper" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="cover" :style="{backgroundImage: `url(${item})`}"></div>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-pagination"></div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    position: relative;
    .cover{
        padding-bottom: 150%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }
    .swiper-pagination{
        position: absolute;
        left: 0;
        bottom: .36rem;
        width: 100%;
        display: flex;
        justify-content: center;
        z-index: 1;
        /deep/{
            .swiper-pagination-bullet{
                margin: 0 .1rem;
                width: .4rem;
                height: .05rem;
                background: #fff;
                transition: all .3s;
                border-radius: 0;
                opacity: 1;
                &.swiper-pagination-bullet-active{
                    background: #000;
                }
            }
        }
    }
}
</style>